<template>
  <div class="row gutter-sm items-center">
    <div class="col">
      <user-avatar :user="user"/>
    </div>

    <div class="col gt-xs">
      <q-icon name="expand_more" size="1.275rem"/>
    </div>
  </div>
</template>

<script>
  import UserAvatar from 'components/Common/UserAvatar.vue'

  export default {
    props: {
      user: {
        type: Object,
        required: true
      },
      activeTeam: {
        type: Object,
        required: false
      }
    },

    components: {
      UserAvatar
    }
  }
</script>
